/**
 * Formats a numeric amount as a localized currency string, displaying the
 * ISO currency code rather than a currency symbol (per Belgian display
 * conventions, so the currency is always unambiguous).
 *
 * @param value - The numeric amount to format.
 * @param currency - The ISO 4217 currency code (e.g. `'EUR'`).
 * @param locale - The locale to format with; defaults to the runtime's default locale.
 * @param maximumFractionDigits - Maximum number of decimal digits to show. Defaults to 2.
 * @returns The formatted currency string, e.g. `"1.234,56 EUR"`.
 */
export function formatCurrency(
  value: number,
  currency: string,
  locale?: string,
  maximumFractionDigits = 2,
) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'code',
    maximumFractionDigits,
  }).format(value);
}
